export default __webpack_public_path__ + "static/media/sa-7-1.0585c1ae.png";